export default {
  rows: [],
  row: {},
  customTaxes: [],
}
